import { createTRPCClient, httpBatchLink } from '@trpc/client';

import type { AppRouter } from '../../../backend/src/trpc/root';
import env from '../app/env';

export const trpc = createTRPCClient<AppRouter>({
    links: [
        httpBatchLink({
            url: `${env.API_PATH}/trpc`,
            // Auth cookies are sent automatically (same-origin).
        }),
    ],
});
